import { SOGetAssessment } from '../assessment/so-get-assessment';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostAssessmentSummary {

  constructor(
    public assessment: SOGetAssessment,
    public project: SOGetProject,
    public organization: SOGetOrganization,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostAssessmentSummary(
      'assessment' in params ? params.assessment : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
